import PaywallProBgRebrand from '@/assets/image/free-to-pay/paywall-pro-bg-mobile-jpg/paywall-pro-bg-mobile-rebrand.png';
import Image, { type ImageProps } from 'next/image';

export const PaywallProBgMobileJpg = (props: Omit<ImageProps, 'src'>) => {
  const { alt = 'paywall pro bg', ...rest } = props;

  return <Image src={PaywallProBgRebrand} alt={alt} {...rest} />;
};
